import dayjs from 'dayjs';

export const displayTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    
    try {
        const messageTime = dayjs(timestamp);
        const now = dayjs();
        const diffInHours = now.diff(messageTime, 'hours');
        
        if (diffInHours < 24) {
            return messageTime.fromNow();
        } else {
            return messageTime.format("MMM D, h:mm A");
        }
    } catch (error) {
        return 'N/A';
    }
};
